export const filterCategoriesFieldsAccordingToPermission = (fields, checkBy) => {
	return fields?.filter(field => {
		const hasIncludeOnly = Array.isArray(field?.include_only)
		return hasIncludeOnly ? field?.include_only.includes(checkBy) : true
	})
}
